// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__19c9H","loaderOuter":"PageOverlayLoader_loaderOuter__3-YKC"};